var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoActivities(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 115,
    viewBox: "0 0 126 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.32804,
    y: 0.0000305176,
    width: 9.61539,
    height: 109.312,
    rx: 4.80769,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    y: 100.679,
    width: 9.61539,
    height: 122.172,
    rx: 4.80769,
    transform: "rotate(90 125.5 100.679)",
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.500015,
    y: 5.65613,
    width: 9.61539,
    height: 109.163,
    rx: 4.80769,
    fill: "#EAECF0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 122.672,
    y: 105.204,
    width: 9.61539,
    height: 122.172,
    rx: 4.80769,
    transform: "rotate(90 122.672 105.204)",
    fill: "#EAECF0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 122.672,
    y: 114.819,
    width: 9.61539,
    height: 109.312,
    rx: 4.80769,
    transform: "rotate(180 122.672 114.819)",
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.499931,
    y: 14.1402,
    width: 9.61539,
    height: 122.172,
    rx: 4.80769,
    transform: "rotate(-90 0.499931 14.1402)",
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 125.5,
    y: 109.163,
    width: 9.61539,
    height: 109.163,
    rx: 4.80769,
    transform: "rotate(180 125.5 109.163)",
    fill: "#EAECF0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.32811,
    y: 9.61545,
    width: 9.61539,
    height: 122.172,
    rx: 4.80769,
    transform: "rotate(-90 3.32811 9.61545)",
    fill: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7751 68.9787L31.0251 46.3158C29.6583 44.9543 29.6583 42.7467 31.0251 41.385L35.9747 36.4542C37.3415 35.0925 39.5577 35.0925 40.9245 36.4542L56.25 51.7209L89.0755 19.0212C90.4423 17.6596 92.6585 17.6596 94.0253 19.0212L98.9749 23.952C100.342 25.3135 100.342 27.5211 98.9749 28.8828L58.7249 68.9789C57.358 70.3404 55.1419 70.3404 53.7751 68.9787Z",
    fill: "#EAECF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2751 90.9787L30.5251 68.3158C29.1583 66.9543 29.1583 64.7467 30.5251 63.385L35.4747 58.4542C36.8415 57.0925 39.0577 57.0925 40.4245 58.4542L55.75 73.7209L88.5755 41.0212C89.9423 39.6596 92.1585 39.6596 93.5253 41.0212L98.4749 45.952C99.8417 47.3135 99.8417 49.5211 98.4749 50.8828L58.2249 90.9789C56.858 92.3404 54.6419 92.3404 53.2751 90.9787Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoActivities);
export default __webpack_public_path__ + "static/media/no-activities.0035dba292fced05d2fb75258c79d8e7.svg";
export { ForwardRef as ReactComponent };